import { Models } from '@rematch/core';
import { createMainAppModal } from '@miotech/esghub-web-lib-common';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
const mainApp = createMainAppModal<IRootModel>();
export interface IRootModel extends Models<IRootModel> {
  mainApp: typeof mainApp; // 用户及公司信息，已登录状态都会用到
}

export const models: IRootModel = {
  mainApp,
};
